const SurveyResultsStore = {
  data: {
    results: [
      {
        id: 0,
        question: `Is there any equipment you would like to purchase, but haven't due to the cost?`,
        answers: [`YES`, `NO`],
        responses: [10,7]
      },
      {
        id: 1,
        question: `What is the most frequent issue you experience with you aquarium?`,
        answers: [`Controlling algae`, `Keeping the water clear`, `Routine maintenance`, `Affordable supplies/equipment`, `Other`],
        responses: [ 7, 1, 8, 3, 3 ]
      },
      {
        id: 2,
        question: `What was the most expensive product you purchased recently?`,
        answers: [`Light`, `Filter`, `Heater`, `Pump`, `Other`],
        responses: [ 8, 3, 0, 3, 3 ]
      },
      {
        id: 3,
        question: `How do you care for, or ensure, your tanks are secure during long periods of absence?`,
        answers: [ `Hire professional`, `Ask friend/neighbor`, `Automated equipment`, `No time available`, `Other`],
        responses: [ 2, 7, 11, 1, 2 ]
      },
      {
        id: 4,
        question: `Where do you most commonly find your information about aquariums?`,
        answers: [ `Aquarium website`, `Books`, `Clubs`, `Publications`, `Other` ],
        responses: [ 11, 4, 6, 4, 4 ]
      },
      {
        id: 5,
        question: `What, in your opinion, prevents new people from entering this hobby?`,
        answers: [`Time`, `Cost`, `Learning curve`, `Residential restrictions`, `Other`],
        responses: [ 6, 10, 11, 0, 1 ]
      }
    ]
  }
};

export default SurveyResultsStore;


// WEBPACK FOOTER //
// ./src/stores/SurveyResultsStore.js